"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.conditions = void 0;
function conditions(runIf, rule) {
    return (value, values, texts) => {
        const isRequired = Object.keys(runIf).every((key) => {
            if (typeof values === 'object' && values != null && values.hasOwnProperty(key)) {
                return values[key] === runIf[key];
            }
            return false;
        });
        if (!isRequired) {
            return '';
        }
        return rule(value, values, texts);
    };
}
exports.conditions = conditions;
//# sourceMappingURL=conditions.js.map